export default __webpack_public_path__ + "static/media/ab-title-en.887856c1.webp";